//
// SymbolImage.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./SymbolTransformable";

var SymbolImage = createModule("gtl::SymbolImage", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::SymbolTransformable"], EventDispatcher, [
    ,
    {
        image: 7,
        colorBlend: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SymbolImage;
